const buildParams = (params) => {
  const searchParams = new URLSearchParams()

  Object.entries(params).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => searchParams.append(key, v))
    } else if (value !== undefined && value !== null) {
      searchParams.append(key, value)
    }
  })

  return searchParams.toString()
}

export default buildParams
